import React, { useEffect } from 'react';
import { Badge } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { refreshNotificationSummary, refreshChatSummary, resetNotifications, selectAlertUnreadCount, selectChatAlertUnreadCount } from '@/store/modules/notifications';

export const NotificationMonitor = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, userInfo, sessionVersion } = useSelector(state => state.user);
  useEffect(() => {
    dispatch(resetNotifications());
    if (!isAuthenticated || !userInfo?.id) return;
    let pending = false;
    const refresh = async () => {
      if (document.hidden || pending) return;
      pending = true;
      try { await Promise.allSettled([dispatch(refreshNotificationSummary()), dispatch(refreshChatSummary())]); }
      catch { /* 轮询失败不弹出重复提示，通知页面提供重试。 */ }
      finally { pending = false; }
    };
    refresh();
    const timer = setInterval(refresh, 20000);
    document.addEventListener('visibilitychange', refresh);
    window.addEventListener('focus', refresh);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', refresh);
      window.removeEventListener('focus', refresh);
    };
  }, [dispatch, isAuthenticated, userInfo?.id, sessionVersion]);
  return null;
};

const NotificationBadge = ({ children, kind = 'all', ...props }) => {
  const notices = useSelector(selectAlertUnreadCount); const chat = useSelector(selectChatAlertUnreadCount);
  const count = kind === 'notifications' ? notices : kind === 'chat' ? chat : notices + chat;
  // Menu 注入的图标 className 和 style 需传给外层，才能保留图标与文字的间距。
  return <Badge {...props} dot={count > 0} offset={[3, 0]}>{children}</Badge>;
};
export default NotificationBadge;
